import axios from 'axios';

// Base configuration for the Axios instance
const api = axios.create({
    timeout: 10000, 
    headers: { 'Content-Type': 'application/json' }
});

// Set the Authorization header if a token exists in localStorage
const tokenFromStorage = localStorage.getItem('token');
if (tokenFromStorage) {
    api.defaults.headers.common['Authorization'] = `Bearer ${tokenFromStorage}`;
}

// Response interceptor for handling errors
api.interceptors.response.use(
    response => response,
    error => {

        return Promise.reject(error);
    }
);

export default api;
